// extracted by mini-css-extract-plugin
export default {"image":"IW-z","loaded":"JW-z"};